var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.32,
    height: 32.32,
    viewBox: "0 0 32.32 32.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M17.467,2a1.345,1.345,0,0,1,.827.284l12.12,9.427a1.347,1.347,0,0,1,.52,1.063V27.587a4.045,4.045,0,0,1-4.04,4.04H8.04A4.045,4.045,0,0,1,4,27.587V12.773a1.347,1.347,0,0,1,.52-1.063L16.64,2.284A1.345,1.345,0,0,1,17.467,2ZM28.24,13.432,17.467,5.053,6.693,13.432V27.587A1.348,1.348,0,0,0,8.04,28.934H26.894a1.348,1.348,0,0,0,1.347-1.347Z",
    transform: "translate(-1.307 -0.653)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M25.427,38.16a1.347,1.347,0,0,1-1.347-1.347V24.693H18.693v12.12a1.347,1.347,0,1,1-2.693,0V23.347A1.347,1.347,0,0,1,17.347,22h8.08a1.347,1.347,0,0,1,1.347,1.347V36.814A1.347,1.347,0,0,1,25.427,38.16Z",
    transform: "translate(-5.227 -7.186)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M0,0H32.32V32.32H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome);
export default __webpack_public_path__ + "static/media/sidebar_home.92fbff9b4e0f50fbfd77692343e18f43.svg";
export { ForwardRef as ReactComponent };